<template>
  	<div class="allOrder">
  		<!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh" v-if="list.length != 0"> -->
  		<van-pull-refresh v-model="refreshing" @refresh="onRefresh"  @touchmove.native.stop.prevent>
			<van-list
			  v-model="loading"
			  :finished="finished"
			  finished-text="没有更多了"
			  @load="onLoad"
			>
			  <van-cell class="lists" v-for="(item, index) in list" :key="index">
			  	<div>
			        <div class="item-i">
			            <div class="item_l"><img :src="item.prize_picture" @error="nofind()"></div>
			            <div class="item_r">
			                <p class="item-title">{{item.prize_name}}</p>
                      <div class="item-status">
                        <p class="btn" v-if="item.status === 1"><span class="address" @click="bindAddress(item.record_id)">请选择收货地址<span  class="img">></span></span><span class="right">{{item.created_at | dateFormat}}</span></p>
                        <p class="status" v-if="item.status === 2"><span>等待平台审核</span> <span class="right">{{item.created_at | dateFormat}}</span></p>
                        <p class="status" v-if="item.status === 3"><span>待发货</span> <span class="right">{{item.created_at | dateFormat}} </span></p>
                        <p class="status" v-if="item.status === 0"><span><span>已发放 </span> <span @click="toLogistics(item.record_id)"  class="logistics" v-if="item.prize_real == 1">查看物流</span></span><span class="right">{{item.created_at | dateFormat}}</span></p>
                        <p class="status" v-if="item.status === -1"> <span>已失效</span> <span class="right">{{item.created_at | dateFormat}}  </span></p>
                         <p class="status" v-if="item.status === -2"> <span class="logistics">已驳回</span> <span @click="viewReject(item.reject_reason)"  class="logistics">查看原因</span><span class="right">{{item.created_at | dateFormat}}</span></p>
                      </div>
			               <popup
                    :titleText="'驳回原因'"
                    :tipMessage="activityOverMessage"
                    :isShow="activityOverShow"
                    @popupConfirm="goBack"
                    >
                    </popup>
			            </div>
			        </div>
		        </div>
		        <!--<div class="btn">
		            <span class="cancel" @click="showPopup(item.ordersn, index)">取消订单</span>
		            <span class="pay" @click="Pay(item)">立即付款</span>
		        </div>-->
			  </van-cell>
			</van-list>
		</van-pull-refresh>
	    <van-row class="empty" v-if="list.length == 0">
			<van-col class="emptyMsg" span="24">
				<img src="../../assets/myInvest/empty.png"/>
				<p class="tip">暂无奖品</p>
			</van-col>
		</van-row>
  	</div>
</template>
<script>
import defaultImg from '@/assets/common/compare.png';
import Popup from "./components/popup.vue"
import { log } from 'util';
export default {
  components: {
    Popup
  },
	props:{
		orderStyle: {
			type: Number,
			detault: 0
    },
    active:{
      type:Number,
      default: 0
    }
	},
	data() {
	    return {
			    list: [],
	      	loading: false,
	      	finished: false,
	      	refreshing: false,
	      	error: false,
	        page: 0,
	        pageSize: 10,
	        // allList: 11, //默认比第一页数据多1
        	cancleOrderSn: 0,
        	cancleIndex: 0,
          orderInfo: {},
          retailLogistics: {},
          activityOverMessage:'',//驳回原因
          activityOverShow:false,//弹框的显示
	    };
  },
  filters: {
    dateFormat(date) {
      return date.replace(/-/g, '.')
    }
  },
	created() {
    //  this.getInfo();
    // console.log(screen.width)
  },
  mounted() {
  },
	methods: {
	  	onLoad() {
        this.page ++;
        this.getInfo();
	    },
	    onRefresh() {
			  this.finished = false;
        this.page = 0;
        this.list = [];
        // this.getInfo();
        this.onLoad()
	    },
	    getInfo() {
	    	  this.$api.post("activity/member/turntable/record/list", {page: this.page, size: this.pageSize}).then(res => {  
            if (res.total === 0 || res.list.length === 0) {
              this.finished = true;
              this.loading = false
              this.refreshing = false  // 解决空列表下拉一直加载中问题
              return
            }
            let _list = []
            switch(this.orderStyle) {
              case 0:
                _list = res.list
                break
              case 10:
                _list = res.list.filter(item => item.prize_real == 0)
                break
              case 20:
                _list = res.list.filter(item => item.prize_real == 1)
                break
            }
            _list.forEach(item => {
              this.list.push(item)
            })
            this.loading = false;
            if (res.current_page === res.last_page) {// 数据全部加载完成
              this.finished = true;
		        }
		        if(this.refreshing) {
		        	this.$toast('刷新成功');
	        		this.refreshing = false;
            }
            if (! this.finished && ! this.loading && this.list.length <= 5) {
              this.onLoad()
            }
            // this.prize_image = _list.forEach(item => prize_picture)
          })
          .catch((err)=>{
            // this.error = true
            // this.refreshing = false
          })
	  	},
	  	bindAddress(record_id) {
	  		this.$router.push({
			    path: "/game/address",
			    query: {
              record_id: record_id,
              active:this.active
			    }
        });
        // this.params(id, id, 'bindAddress')  
      },
     
      toLogistics(record_id) {
        // alert(record_id);
        this.$api.post("activity/member/turntable/express/get",{record_id:record_id}).then(data=>{
          // console.log(data);
        const retailLogistics= {
          post_name: data.express_company,
          post_code: data.express_code,
          post_no: data.express_order,
          prize_image: data.prize_picture
        }     
//           const retailLogistics= {
//             post_name: "顺丰快递公司",
//             post_code: "顺丰快递",
//             post_no: "X41635341",
//           }
          // this.toLogistics()
          this.params(JSON.stringify(retailLogistics), JSON.stringify(retailLogistics), 'toLogistics'); //跳转原生
        }) 
      },
      viewReject(text){
        this.activityOverMessage=text;
        this.activityOverShow=true;
      },
      goBack() {
        this.activityOverShow=false;
    },

	  	nofind() {
		    var img = event.srcElement;
			  img.src = defaultImg;
			  img.onerror = null; //防止闪图
		  }
	}
};

</script>
<style lang="less">
.allOrder{
    .van-pull-refresh__track{
      padding-bottom: 130px;
    }
    background-color: #ffffff;
	  // padding: 0 16px;
	  height: 100%;
    .van-pull-refresh {
      padding: 0 16px;
      height: 591px; //解决无限滚动问题,及列表最后一个显示不全问题。
      padding: 0 16px 400px 16px;
	    overflow-y: scroll;
      -webkit-overflow-scrolling:touch;
      .lists {
        border-radius: 5px;
        background: #fff;
        padding: 16px 0;
      }
    }
	.empty {
		padding-top: 10px;
		.emptyMsg {
			text-align: center;
			img {
				width: 106px;
				display: inline-block;
			}
			.tip {
				color: #CCCCCC;
				font-size: 14px;
				margin-top: 17px;
				height: 20px;
				line-height: 20px;
			}
		}
	}
}	
</style>
<style scoped>
.all .lists {
  border-radius: 5px;
  background: #fff;
  padding: 16px 0;
}
.van-cell:not(:last-child):after {
	left: 0;
}
.all .lists .item {
  padding: 0 12px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #EEEEEE;
  line-height: 43px;
  padding-right: 72px;
  position: relative;
}
.item-i{
    display: flex;
    /*padding: 13px 12px 0;*/
}
.item_l{
    width: 70px;
    height: 70px;
    background: #D8D8D8;
    margin-right: 12px;
}

.item_l img{
	width: 100%;
	height: 100%;
    /*border-radius: 3px;*/
}
.item_r{
	width: calc(100% - 82px);
}
.item_r p{
    /*margin-top: 8px;
    font-size: 12px;
    color: #999999;
    font-weight: 400;
    line-height: 12px;
    padding-top: 6px;*/
}
.item_r .item-status .status,
.item_r .item-status .btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.item_r .item-title{
    margin-top: 0;
    font-size: 16px;
    line-height: 27px;
    font-weight: 500;
    color: #333333;
    font-weight: bold;
    white-space: nowrap;
    text-overflow:ellipsis; 
    overflow:hidden;
}
.item_r .status{
    margin-top: 12px;
    font-size: 15px;
    color: #999999;
    font-weight: 400;
    line-height: 21px;
}
.item_r .address {
	color: #FF7300;
	font-size: 15px;
	width: 123px;
	height: 31px;
	line-height: 31px;
	border: solid 1px #FF9844;
	border-radius: 15px;
	/* margin-top: 7px; */
	text-align: center;
	display: inline-block;
}
.item_r .logistics {
  color: #FF7300;
}
.item_r .address .img {
	margin-left: 3px;
}
.item_r .right {
	color: #C0C0C0;
	font-size: 13px;
	/* float: right; */
	height: 21px;
	line-height: 21px;
}
/* @media screen and (max-width:374px){
	.item_r .address{
	    font-size: 13px;
	}
} */

@media screen and (max-width:330px){
  .item_l {
    margin-right: 6px;
  }
	.item_r .address{
	    font-size: 12px;
      width: 90px;
	}
  .item_r .right{
    font-size: 12px;
  }
}

@media screen and (max-width:374px){
  .item_l {
    margin-right: 6px;
  }
	.item_r .address{
	    font-size: 13px;
      width: 110px;
	}
  .item_r .right{
    font-size: 13px;
  }
}



/*.btn{
   display: flex;
   justify-content: flex-end;
   padding: 0 12px; 
   margin-top: 16px;
}
*/
.btn {
  margin-top: 12px;
}
/*
.btn span{
    width: 72px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    border-radius: 14px;
    font-size: 14px;
    color: #999999;
}
.btn .cancel{
    border: 1px solid #979797;
    margin-right: 12px;
}
.btn .pay{
    border: 1px solid #D29A6E;
    color: #D29A6E;
}*/
</style>


